import { iQuote } from "../../../store/Quotes";

export interface IListOfQuotes {
  listOfQuotes: iQuote[];
}

export const Quote = ({ quote }: { key: any; quote: iQuote }) => {
  return (
    <div className="card">
      <div className="card-body">
        <p className="card-text">{quote.text}</p>
      </div>
      <div className="card-footer">{100 - Math.floor(quote.distance * 100)}  %</div>
    </div>
  );
};

export const ListOfQuotes = ({ listOfQuotes }: IListOfQuotes) => {
  return (
    <div className="row mt-2">
      {listOfQuotes.map((quote) => {
        return (
          <div className="col-md-6 col-12 mt-2">
            <Quote key={quote.id} quote={quote}></Quote>
          </div>
        );
      })}
    </div>
  );
};
